export default __webpack_public_path__ + "static/media/logoUnimedLit.416a5c16.png";